import React, { memo } from 'react';

import { useTranslation } from 'react-i18next';

import { CustomModal } from '@shared/ui';

import cls from './ModalVisualization.module.css';
import { ModalVisualizationBody } from './ModalVisualizationBody/ModalVisualizationBody';
import { useModalVisualization } from './useModalVisualization';

export const ModalVisualization = memo(() => {
    const { modalMode, onCancel } = useModalVisualization();

    const { t } = useTranslation();

    return (
        <CustomModal
            contentClasses={cls.ModalVisualization}
            isOpen={modalMode === 'visualization'}
            onHideModal={onCancel}
        >
            <CustomModal.Header>{t('ModalVisualization.return.modalHeader')}</CustomModal.Header>
            <CustomModal.Body>
                <ModalVisualizationBody />
            </CustomModal.Body>
        </CustomModal>
    );
});
